module.exports = __webpack_public_path__ + "static/img/newsimg6.ef97a586.jpg";